import {createAsyncThunk, createSlice} from '@reduxjs/toolkit';

const initialState={
    filesList:[],
    selectedFile: null,
    status:"idle",
    registerstatus:'failure',
    editstatus:'failure',
    deletestatus:'failure',
    error:''
}

export const fetchFiles=createAsyncThunk('files/fetchFiles', async ()=>{
    const username = 'admin'
    const password = 'survive9'
    const auth = btoa(`${username}:${password}`)
    const response = await fetch(
        '/baskets/productfiles/getAllFileRecords',
        {
            headers: {
                'Authorization': `Basic ${auth}`,
                'Accept': 'application/json'
            }
        }
    )
    return response.json()
})

export const fetchFileById=createAsyncThunk('files/fetchFileById', async (id)=>{
    const username = 'admin'
    const password = 'survive9'
    const auth = btoa(`${username}:${password}`)
    const response = await fetch(
        `/baskets/productfiles/getFileRecordById/${id}`,
        {
            headers: {
                'Authorization': `Basic ${auth}`,
                'Accept': 'application/json'
            }
        }
    )
    return response.json()
})

export const createFile=createAsyncThunk('files/createFile', async (file)=>{
    const username = 'admin'
    const password = 'survive9'
    const auth = btoa(`${username}:${password}`)
    const response = await fetch(
        '/baskets/productfiles/addFileRecord',
        {
            method:'POST',
            body: JSON.stringify(file),
            headers: {
                'Authorization': `Basic ${auth}`,
                'Content-Type': 'application/json'
            }
        }
    )
    return response.json()
})

export const updateFile = createAsyncThunk('files/updateFile', async ({fileData, id})=>{
    const username = 'admin'
    const password = 'survive9'
    const auth = btoa(`${username}:${password}`)
    const response = await fetch(
        `/baskets/productfiles/updateFileRecord/${id}`,
        {
            method: 'POST',
            headers: {
                'Authorization': `Basic ${auth}`,
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(fileData)
        }
    )
    return response.json()
})

export const deleteFile = createAsyncThunk('files/deleteFile', async (id)=>{
    const username = 'admin'
    const password = 'survive9'
    const auth = btoa(`${username}:${password}`)
    const response = await fetch(
        `/baskets/productfiles/deleteFileRecord/${id}`,
        {
            method: 'GET',
            headers: {
                'Authorization': `Basic ${auth}`,
                'Accept': 'application/json'
            }
        }
    )
    return response.json()
})

const filesSlice = createSlice({
    name:'files',
    initialState,
    reducers:{
        changeRegisterStatus: (state) => {
            state.registerstatus = 'failure';
        },
        changeEditStatus: (state) => {
            state.editstatus = 'failure';
        },
        changeDeleteStatus: (state) => {
            state.deletestatus = 'failure';
        },
    },
    extraReducers:(builder)=>{
        builder
        .addCase(fetchFiles.pending, (state)=>{
            state.status='loading'
        })
        .addCase(fetchFiles.fulfilled, (state, action)=>{
            state.status='succeeded'
            state.filesList=action.payload
        })
        .addCase(fetchFiles.rejected, (state, action)=>{
            state.status='failed'
            state.error=action.error.message
        })
        .addCase(fetchFileById.pending, (state)=>{
            state.status='loading'
        })
        .addCase(fetchFileById.fulfilled, (state, action)=>{
            state.status='succeeded'
            state.selectedFile=action.payload
        })
        .addCase(fetchFileById.rejected, (state, action)=>{
            state.status='failed'
            state.error=action.error.message
        })
            .addCase(createFile.pending, (state)=>{
                state.registerstatus = 'loading';
            })
            .addCase(createFile.fulfilled, (state, action)=>{
                state.registerstatus = 'success';
            })
            .addCase(createFile.rejected, (state, action)=>{
                state.registerstatus = 'failure';
            })
            .addCase(updateFile.pending, (state)=>{
                state.editstatus = 'loading';
            })
            .addCase(updateFile.fulfilled, (state, action)=>{
                state.editstatus = 'success';
            })
            .addCase(updateFile.rejected, (state, action)=>{
                state.editstatus = 'failure';
            })
            .addCase(deleteFile.pending, (state)=>{
                state.deletestatus = 'loading';
            })
                .addCase(deleteFile.fulfilled, (state, action)=>{
                    state.deletestatus = 'success';
                })
                .addCase(deleteFile.rejected, (state, action)=>{
                    state.deletestatus = 'failure';
                })

    }
})

export default filesSlice.reducer;